import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonListHeader, IonList, IonItem, IonLabel, IonThumbnail } from '@ionic/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { milesOrPoints } from '../app/miles-or-points';
import { selectAvailableVideos, selectMode } from '../features/log/logSlice';

const Videos: React.FC = () => {
  const content = useSelector(selectAvailableVideos),
    mode = useSelector(selectMode);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Content</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonListHeader><h2>Unlocked Content</h2></IonListHeader>
        <IonList>
          {content
            .sort((a, b) => a.unlocked_after <= b.unlocked_after ? 1 : -1)
            .map(data => 
            <IonItem
              routerLink={`/content/${data.id}`}
              key={`${data.unlocked_after}-${data.id}`}
            >
              {data.hasOwnProperty('thumbnail') && <IonThumbnail slot="start">
                <img src={`/assets/content/${data.id}-thumbnail.png`} alt={data.title}/>
              </IonThumbnail>}
              <IonLabel>
                <h3>{data.title}</h3>
                <h4>{data.author}</h4>
                {data.scripture && <p>{data.scripture}</p>}
                <p>Unlocked after {data.unlocked_after} {milesOrPoints(mode, data.unlocked_after ?? 0)}</p>
              </IonLabel>
            </IonItem>
          )}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Videos;